// Platform configuration - loaded from environment or API

export interface PlatformConfig {
  platformDomain: string
  platformName: string
}

let _config: PlatformConfig | null = null

export function getPlatformConfig(): PlatformConfig {
  if (_config) return _config
  
  // Try to get from Vite env vars first
  _config = {
    platformDomain: import.meta.env.VITE_PLATFORM_DOMAIN || window.location.host,
    platformName: import.meta.env.VITE_PLATFORM_NAME || 'Camp Cloud',
  }
  
  return _config
}

export function getTenantUrl(slug: string): string {
  const config = getPlatformConfig()
  const protocol = window.location.protocol
  
  // Always use path-based routing for better compatibility
  // Subdomains require wildcard SSL which Pages doesn't support easily
  return `${protocol}//${config.platformDomain}/t/${slug}`
}

export function getTenantAdminUrl(slug: string): string {
  return `${getTenantUrl(slug)}/admin`
}

